var _desc, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 25",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7150514,3.00730525 C12.2138639,3.0849379 11.0093979,3.77667259 10.1067787,4.8598156 C10.0594985,4.91878786 9.97336392,4.92826616 9.91439166,4.88098598 C9.9065819,4.87472462 9.89948264,4.86762536 9.89322128,4.8598156 L9.89322128,4.8598156 L9.89322128,4.8598156 C8.93418841,3.70897615 7.63439879,3 6,3 C3.04505953,3 1,5.07346156 1,7.85185185 C1,11.1910124 3.87901268,14.4832167 9.48433806,17.8567921 C9.80159856,18.047736 10.1984014,18.047736 10.5156619,17.8567921 C16.1209873,14.4832167 19,11.1910124 19,7.85185185 C19,5.07346156 16.9549405,3 14,3 L13.7150514,3.00730525 Z M14,5 C15.8441492,5 17,6.17190343 17,7.85185185 L16.9956177,8.03094205 C16.8845707,10.3076883 14.6620324,12.8978143 10.2064294,15.6991512 L10,15.827 L9.79357062,15.6991512 C5.22071488,12.8240949 3,10.1715122 3,7.85185185 C3,6.17190343 4.15585084,5 6,5 C6.99060121,5 7.75331159,5.41602385 8.35677872,6.1401844 C8.57735449,6.40487533 8.7592756,6.69211919 8.90244781,6.9784636 C8.96882678,7.11122154 9.01337507,7.21503459 9.03725956,7.2774105 L9.0513167,7.31622777 C9.34140189,8.18648334 10.5295875,8.22604041 10.9013182,7.43489898 L10.9845465,7.22305429 C11.0102635,7.16131901 11.047768,7.07803205 11.0975522,6.9784636 C11.2407244,6.69211919 11.4226455,6.40487533 11.6432213,6.1401844 C12.2466884,5.41602385 13.0093988,5 14,5 Z",
    fill: "#000000",
    fillRule: "nonzero"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 35,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Roberto Chiaveri")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 40,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHeart);
export default __webpack_public_path__ + "static/media/empty-heart.50eefdd830d26268d710f10d62cab297.svg";
export { ForwardRef as ReactComponent };